import React from 'react';
import { SvgIcon, SvgIconProps } from '../../components/svgIcon';

export const AddIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="mobileMenu/add" ref={ref as any} {...props}>
      <circle cx="12" cy="12" fill="#D6DEE2" r="8.25" />
      <path
        d="M20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12ZM5.27345 12C5.27345 15.715 8.28503 18.7266 12 18.7266C15.715 18.7266 18.7266 15.715 18.7266 12C18.7266 8.28503 15.715 5.27345 12 5.27345C8.28503 5.27345 5.27345 8.28503 5.27345 12Z"
        fill="#7E8C9C"
      />
      <rect fill="#7E8C9C" height="7.5" rx="0.75" width="1.5" x="11.25" y="8.25" />
      <rect fill="#7E8C9C" height="1.5" rx="0.75" width="7.5" x="8.25" y="11.25" />
    </SvgIcon>
  );
});
